var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center text-nowrap no-wrap"},[_c('status-solicitacao-icon',{staticClass:"fa-fw",attrs:{"status":_vm.status}}),_c('span',{staticClass:"text-black"},[_vm._v(_vm._s(_vm.getStatus(_vm.status).title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }